/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.modals.rescheduleEvent.controllers', [
  'acme.common.service.calendar',
  'acme.common.directive.resourceAvailability',
  'acme.view.application.orders.modals.privateEvent.constants',
  'acme.view.application.orders.modals.privateEvent.directive.eventDate',
  'acme.common.service.userPreferences',
  'acme.common.service.validate'
])

.controller('ProgramsModalsRescheduleEventController', [
  '$scope',
  '$filter',
  '$timeout',
  '$uibModalInstance',
  'eventInstance',
  'resourcesCount',
  'template',
  'CalendarService',
  'UserPreferencesService',
  'ValidateService',
  'PRIVATE_EVENT_SCHEDULE_TYPE',
  function(
    $scope,
    $filter,
    $timeout,
    $uibModalInstance,
    eventInstance,
    resourcesCount,
    template,
    CalendarService,
    UserPreferencesService,
    ValidateService,
    PRIVATE_EVENT_SCHEDULE_TYPE
  ) {

    $scope.programsModalsRescheduleEvent = {

      model: {
        id: '',
        startTime: new Date(),
        endTime: new Date(),
        moveResources: true,
        selectedResourcesList: {},
        notifyBuyers: false
      },

      isLoading: false,
      isSaving: false,
      isSubmitted: false,

      selectedResourcesList: {},

      event: {},
      eventStartHour: new Date(),
      duration: {
        hour: 1,
        minutes: 30
      },

      resources: [],
      resourcesCount: 0,

      template: false,

      errors: {},

      startTime: new Date(),
      hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
      timesTab: PRIVATE_EVENT_SCHEDULE_TYPE.private.name, 
      privateSchedule: false,
      privateScheduleTime: false,
      privateScheduleTimes: [],
      privateDuration: false,

      init: function() {
        var self = $scope.programsModalsRescheduleEvent; 

        this.event = eventInstance;
        this.resourcesCount = resourcesCount;

        if(template.data && template.data.payload) {
          this.template = template.data.payload;
        }

        this.setModel();
        this.getDuration();
        this.getPrivateSchedules();

        $scope.$watchGroup(['programsModalsRescheduleEvent.model.date', 'programsModalsRescheduleEvent.model.timeMin','programsModalsRescheduleEvent.model.durationMin'], function() {
          self.tryClearErrors();
        });

        $scope.$watch('programsModalsRescheduleEvent.model.timeHr', function(newVal, oldVal) {
          if (newVal && !self.model.timeMin) {
              self.model.timeMin = '00';
          }
            self.tryClearErrors();
        });

        $scope.$watch('programsModalsRescheduleEvent.model.durationHr', function(newVal, oldVal) {
            if (newVal && !self.model.durationMin) {
                self.model.durationMin = '00';
            }
            self.tryClearErrors();
        });

        $scope.$watchGroup([
          'programsModalsRescheduleEvent.timesTab',
          'programsModalsRescheduleEvent.privateScheduleTime', 
          'programsModalsRescheduleEvent.model.timeHr',
          'programsModalsRescheduleEvent.model.timeMin',
          'programsModalsRescheduleEvent.model.timeAm',
          'programsModalsRescheduleEvent.model.durationHr',
          'programsModalsRescheduleEvent.model.durationMin'
        ], function() {
          var self = $scope.programsModalsRescheduleEvent;

          self.eventStartHour = new Date(self.getSelectedTime());

          self.model.duration = {
            hour: self.model.durationHr || '0',
            minutes: self.model.durationMin || '00'
          };
        });
      },

      tryClearErrors: function() {
        var self = this;
        if (Object.keys(self.errors).length === 0) {
            return;
        }
        $timeout.cancel($scope.validateTimer);
        $scope.validateTimer = $timeout(function() {
            ValidateService.validate(self.getValidators());
            self.errors = ValidateService.getErrorHash();
        }, 2000);
    },

      setModel: function() {
        this.model.id = this.event.id;
        this.startTime = new Date(this.event.startTime);
      },

      getDuration: function() {
        var diffMilliSec = new Date(this.event.endTime) - new Date(this.event.startTime);
        this.duration.hour = Math.floor(diffMilliSec / 3600000);
        this.duration.minutes = Math.round(((diffMilliSec % 86400000) % 3600000) / 60000);
        this.model.durationHr = this.duration.hour;
        this.model.durationMin = this.duration.minutes;
      },

      updateEventStartHour: function() {
        this.eventStartHour = new Date(this.event.startTime);
      },

      getSelectedTime: function() {
        var self = $scope.programsModalsRescheduleEvent,
            d = moment(self.model.date),
            timeAm = self.model.timeAm ? 'AM' : 'PM',
            isPrivateSchedule = (self.privateSchedule && self.isActiveTab('private') && self.privateScheduleTime),
            militaryTime = (isPrivateSchedule) ? 
              moment().hour(self.privateScheduleTime.hour).minute(self.privateScheduleTime.minutes).second(0).format('HH:mm:ss') : 
              moment(self.model.timeHr + ':' + self.model.timeMin + ':00 ' + timeAm, 'h:mm:ss A').format('HH:mm:ss'),
            dateTime = moment(d.format('YYYY-MM-DD') + 'T' + militaryTime);
            
        return dateTime.format('YYYY-MM-DDTHH:mm:ssZZ');
      },

      updateModel: function() {
        var self = $scope.programsModalsRescheduleEvent;

        self.model.startTime = self.getSelectedTime();

        self.model.duration = {
          hour: self.model.durationHr,
          minutes: self.model.durationMin
        };
        self.model.selectedResourcesList = self.selectedResourcesList;

        self.isSaving = true;
      },

      hasResources: function() {
        return (this.resourcesCount > 0);
      },

      done: function() {
        var self = this;

        self.isSubmitted = true;

        if (!ValidateService.validate(this.getValidators())) {
            this.errors = ValidateService.getErrorHash();
            return;
        }

        self.isSaving = true;
        self.isSubmitted = false;

        this.updateModel();
        $uibModalInstance.close(this.model);
      },

      isActiveTab: function(type) {
        return (type === this.timesTab);
      },

      getValidators: function() {
        var priceListName = '',
            validators = [];

        if (this.model.priceList) {
            priceListName = this.model.priceList.name;
        }

        validators = [
            {field: 'private-event-date', dateAfterYesterday: {message: 'Invalid date.', test: {value: this.model.date }}},
            {field: 'private-event-duration-hr', greater: {message: ' ', test: {greater: this.model.durationHr, less: -1 }}},
            {field: 'private-event-duration-min', greater: {message: ' ', test: {greater: this.model.durationMin, less: -1 }}}
        ];

        if (this.isActiveTab('standard') || !this.hasPrivateSchedulesTimes()) {
          validators.splice(1, 0,
            {field: 'private-event-time-hr', greater: {message: ' ', test: {greater: this.model.timeHr, less: 0 }}},
            {field: 'private-event-time-min', greater: {message: ' ', test: {greater: this.model.timeMin, less: -1 }}}
          );
        }

        return validators;
    },

    isValid: function(field) {
      var r = true,
          text = this.model[field] ? this.model[field].name : '';

      // Check if submitted or bypass validation on command
      if(this.isSubmitted) {
        r = ValidateService.validate([
          {
            len: {
              value: text
            }
          }
        ]);
      }

      return r;
    },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      getPrivateSchedules: function() {
        var self = $scope.programsModalsRescheduleEvent,
            schedules = this.template.schedules;

        if (schedules && schedules.length) {
          schedules.forEach(function(item) {
            if (item.type === PRIVATE_EVENT_SCHEDULE_TYPE.private.name) {
              self.privateSchedule = item;
              self.model.date = CalendarService.parseDate(self.startTime);
              self.privateDuration = angular.copy(item.duration);
              self.setPrivateScheduleTimes();
            }
          });
        }
      },

      setPrivateScheduleTimes: function() {
        var self = $scope.programsModalsRescheduleEvent;

        if (this.hasPrivateSchedulesTimes()) {
          this.privateScheduleTimes = this.privateSchedule.hours.map(function(opening) {
            var date = new Date();

            date.setHours(opening.hour);
            date.setMinutes(opening.minutes);
            date.setSeconds(0);
            date.setMilliseconds(0);

            opening.id = date;
            opening.name = $filter('date')(CalendarService.parseDate(date), self.hourFormat);
            opening.date = date;

            return opening;
          });

          if (this.privateScheduleTimes.length) {
            this.privateScheduleTime = this.privateScheduleTimes[0];
          }
        }
      },

      hasPrivateSchedulesTimes: function () {
        return (this.privateSchedule.hasOwnProperty('hours') && this.privateSchedule.hours.length);
      }

    };

    $scope.programsModalsRescheduleEvent.init();

}]);